module.exports = __webpack_public_path__ + "img/8-5.b06eeab6.jpg";